import { render, staticRenderFns } from "./MovieItem.vue?vue&type=template&id=b8fbccb2&scoped=true&"
import script from "./MovieItem.vue?vue&type=script&lang=js&"
export * from "./MovieItem.vue?vue&type=script&lang=js&"
import style0 from "./MovieItem.vue?vue&type=style&index=0&id=b8fbccb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fbccb2",
  null
  
)

export default component.exports